import React, {
  memo
} from "react";
import {
  StyleSheet
} from "react-native";
import {
  YStack
} from "tamagui";
import ModernChartWrapper from "@components/Charts/ModernChartWrapper";
import PercentageBar from "@components/Global/PercentageBar";
import {
  MODERN_CHART_COLORS
} from "@utils/chartTheme";

const summaryData = [{
  label: "System",
  value: "92%",
  color: MODERN_CHART_COLORS.line.primary,
}, {
  label: "Quality",
  value: "87%",
  color: MODERN_CHART_COLORS.line.secondary,
}, {
  label: "Engagement",
  value: "78%",
  color: MODERN_CHART_COLORS.line.tertiary,
},];

const PerformanceWidget = () => (
  <ModernChartWrapper
    title="Performance Metrics"
    subtitle="Monitor system performance indicators"
    summaryData={summaryData}
    style={styles.wrapper}
  >
    <YStack gap={10}>
      <PercentageBar
        title="System Performance"
        percentage={92}
        backgroundColor="#4CAF50"
        completedColor="#2196F3"
        height={25}
      />
      <PercentageBar
        title="Data Quality"
        percentage={87}
        backgroundColor="#FF9800"
        completedColor="#4CAF50"
        height={25}
      />
      <PercentageBar
        title="User Engagement"
        percentage={78}
        backgroundColor="#9C27B0"
        completedColor="#FF5722"
        height={25}
      />
    </YStack>
  </ModernChartWrapper>
);

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
  },
});

export default memo(PerformanceWidget);
